import React from 'react'
import { Box, List, ListItem, Typography, useTheme } from '@mui/material'
import { formatCamelCase } from 'components/DataGrid/operators/formatCamelCase'

const RequestButtonTooltip = ({ newDeal, isValid, saveRequired, validationErrors }) => {
  const theme = useTheme()
  return (
    <>
      {!isValid ? (
        <Box sx={{ textAlign: 'left' }}>
          <Typography sx={{ fontSize: 16, color: 'text.primary', mb: 1 }}>{'Request Approval'}</Typography>
          <Typography sx={{ color: 'text.secondary' }}>Required:</Typography>
          <List>
            {Object.entries(validationErrors)
              .filter(([key, value]) => value === true) // Only include errors with value `true`
              .map(([key]) => (
                <ListItem key={key}>
                  <Typography sx={{ color: theme.palette.text.error }}>{formatCamelCase(key)}</Typography>
                </ListItem>
              ))}
            {saveRequired && (
              <ListItem>
                <Typography sx={{ color: theme.palette.text.error }}>Save Required</Typography>
              </ListItem>
            )}
          </List>
        </Box>
      ) : (
        <>
          {!newDeal.isRequested ? (
            <Typography sx={{ fontSize: 16 }}>{'Request Approval'}</Typography>
          ) : !newDeal.isApproved && !newDeal.isCompleted ? (
            <Typography sx={{ fontSize: 16, color: 'text.warning' }}>{'Awaiting Approval'}</Typography>
          ) : newDeal.isRequested && !newDeal.isApproved ? (
            <Typography sx={{ fontSize: 16 }}>{'Request Sent'}</Typography>
          ) : (
            <Typography sx={{ fontSize: 16, color: 'text.success' }}>{'Request Approved'}</Typography>
          )}
        </>
      )}
    </>
  )
}

export default RequestButtonTooltip
